<script setup>
// auth store
import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

</script>

<template>
	<SectionCard title="App Documentation" v-if="auth.isAdmin">
		<Heading size="2">Handling Membership Applications</Heading>

		<p class="mb-4">Anyone can fill out a membership application form by visiting this url: <Link :href="route('membership-application.create')">{{ route('membership-application.create') }}</Link>.</p>

		<p>In order to view submitted membership applications, admins can click on the "Membership Applications" link in the site nav:</p>
		
		<img src="/images/docs/membership-applications-nav-link.png" class="p-8" />

		<p>You will see a list of all membership applications:</p>

		<img src="/images/docs/membership-applications-list.png" class="w-full p-8" />

		<p>Click on an application in the list to review the details and approve or deny it by using the buttons at the bottom of the page:</p>
		
		<img src="/images/docs/approve-deny-applications-buttons.png" class="w-full p-8" />

		<p class="mb-4">Note that the app does not handle creating payment schedules or Xero invoices. You will need to create invoices in Xero manually, as part of your onboarding process.</p>

		<p>When a user submits a membership application, a new organisation is automatically created and set to a 'PENDING' membership status. You can view this organisation record by clicking the link at the top right of the application review page:</p>

		<img src="/images/docs/view-organisation-from-application.png" class="w-full p-8" />

		<p class="mb-4">The user will also need to add a payment method during the application process, however if they do not complete that step, the application will still appear in the list of pending applications. In order to check if the user added a payment method, click the link to the organisations view page as above, and check the "Payment Methods" section as usual.</p>

		<p>After manual review you may approve or deny the application. If you approve the application, the organisation will be set to an 'ACTIVE' membership status and the user will be sent an email to log in and use the site:</p>
		
		<img src="/images/docs/application-approved-email.png" class="mx-auto p-8" />

		<p>If you deny the application, the organisation will be deleted (but still recoverable) and the user will be sent an email informing them of the denial:</p>
		
		<img src="/images/docs/application-denied-email.png" class="mx-auto p-8" />

	</SectionCard>
</template>